import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-attachments',
  styles: [`
    .nns-attachments-list {
      padding:26px 0 0 0;
    }
    .nns-attachments-list-layout {
      max-height:249px;
      overflow:auto;
    }

    .nns-attachments-opened {display:block;}

    @media only screen and (max-width: 768px) {
      .nns-attachments-list-layout {max-height:209px;}

    }

    @media only screen and (max-width: 600px) {

      .nns-attachments-list {
        padding:0;
        margin:0 -10px;
        display:block;
      }
      .nns-attachments-list-layout {
        padding:0 10px;
        max-height:none;
      }
    }
  `],
  template: `
    <div class="nns-attachments-layout" flex layout="column">
      <div class="nns-attachments-list" flex="none">
        <div class="nns-attachments-list-layout" flex layout="row" layout-align="start start" layout-wrap>
          <nns-attachments-list-item
            *ngFor="let attachment of attachments"
            [attachment]="attachment"
            [attachmentBases]="attachmentBases"
          ></nns-attachments-list-item>
        </div>
      </div>
    </div>
  `,
})
export class AttachmentsComponent {
  @Input() attachments;
  @Input() attachmentBases;
}
